module.exports = __webpack_public_path__ + "static/Sprouts_pin-c3aeced6ebbe3199574fa12823c77107.png";